import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const loginVerifyOtp = (otp: string, mobileNumber: string, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.loginVerifyOTP,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      priMobNo: mobileNumber,
      otp,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { loginVerifyOtp }
